<template>
  <vx-card class="md:w-1/2 upload-card">
    <div class="mt-4">
      <div v-if="isUploaded">
        <img style="width:100%" :src="imgPath" :alt="imgName">
      </div>
      <div v-else>
        <feather-icon class="upload-icon" icon="UploadIcon"></feather-icon>
        <p class="mt-4 text-center">选择图片</p>
      </div>
    </div>
    <input class="upload-input" type="file" @change="upload($event)" accept="image/*">
    <vs-progress v-if="!showProgress" :percent="currentProgress" color="primary">primary</vs-progress>
    <p v-else class="text-center text-sm" style="color: #aaa">（点击重新上传）</p>
  </vx-card>
</template>

<script>

import { uploadImage } from '@/api/upload'
import { getToken } from '@/utils/tools'

export default {
  name: 'upload-image',
  props: {
    default: String,
    url: String,
  },
  data () {
    return {
      imgName: '',
      imgPath: '',
      progress: 0,
      allowMaxSize: 500 * 1024
    }
  },
  created() {
    if (this.url) {
      this.imgPath = this.url
      this.imgName = this.url
      this.progress = 100
    } else {
      this.imgPath = this.default
    }
    
  },
  computed: {
    isUploaded() {
      return this.imgName != ''
    },
    currentProgress() {
      return this.progress
    },
    showProgress() {
      return this.progress === 100
    }
  },
  methods: {
    checkSize(size) {
      if (size > this.allowMaxSize) {
        this.$vs.notify({color:'danger', text: '上传图片不能大于500Kb'})
        return false
      }
      return true
    },
    upload(e) {
      let that = this
      
      const files = e.target.files
      if (files.length == 0) {
        return
      }
      if (!that.checkSize(files[0].size)) {
        return
      }
      that.imgName = files[0].name
      that.progress = 0
      console.log(files[0])

      const formData = new FormData()
      formData.append('access_token', getToken())
      formData.append('file', files[0])

      // 配置
      let config = {
        data: formData,
        onUploadProgress: event => {
          let complete = (event.loaded / event.total * 100 | 0)
          that.progress = complete
        }
      }

      uploadImage(config).then(res => {
        if (res.data.path !== undefined) {
          const data = res.data
          that.imgPath = data.path
          that.$emit('url', data.path)
          that.$vs.notify({
            color: 'success',
            title: '提示',
            text: '上传成功！',
            iconPack: 'feather',
            icon:'icon-alert-circle'
          })
        } else {
          that.imgName = ''
          that.progress = 0
        }
      })
    }
  }
}
</script>

<style>
  .upload-card:hover {
    box-shadow: 1px 1px 24px #ccc;
  }
  .upload-icon {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
  .upload-input {
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0;
    position: absolute;
    top:0;
    left: 0;
    cursor: pointer;
  }
</style>